import React from 'react'
import Header from '../inc/Header'
import Product from './Product'
import { Link } from "react-router-dom";
import Youtubevideo from './Youtubevideo';

function Productspage() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        
              <div className='newback'>
                <div className="album py-1">
        
                  <div className="container  mt-3">
        
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Products</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
        <Product/>
        <br/>
        <Youtubevideo/>
    </div>
  )
}

export default Productspage